import { useNavigate } from "react-router-dom";
import { isDefined, isNumber, isObject } from "@pheaa/channels-component-library";

const useNavigateQSA = () => {

	const navigate = useNavigate();

	return (to, navigateOptions = {}) => {
		let pathname = to, search;
		const queryParameters = new URLSearchParams(window.location.search);

		isObject(to) && ({ pathname = window.location.pathname, search } = to);

		if (isObject(search)) {
			Object.keys(search).forEach(key => {
				if (isDefined(search[key])) {
					queryParameters.set(key, search[key]);
				} else {
					queryParameters.delete(key);
				}
			});
		}

		if (isNumber(pathname)) {
			navigate(pathname);
		} else {
			navigate({ pathname, search: queryParameters.toString() }, navigateOptions);
		}
	};
};

export default useNavigateQSA;